import React, { Component } from 'react'
import ReactDOM from 'react-dom'
//style
import './style.css'

class KeepAlive extends Component {
  constructor(props){
    super(props);
    this.overlayContainer = document.createElement('div')
    document.body.appendChild(this.overlayContainer)
  }

  componentWillUnmount(){
    document.body.removeChild(this.overlayContainer)
  }

  render(){
    return ReactDOM.createPortal(
        <div className="overlay">
          Server is Alive
        </div>,
        this.overlayContainer
      )
  }
}

export default KeepAlive



// WEBPACK FOOTER //
// ./src/components/KeepAlive/index.js